import type { EventPayload, EventParams, ItemData } from "./types";
import { configManager } from "./config";
import { getOrCreateClientId } from "./client-id";
import { getTrafficData } from "./utm";
import { generateUUID } from "./utils";

/** 获取当前页面信息 */
function getPageData() {
  return {
    href: window.location.href,
    title: document.title,
    referrer: document.referrer,
  };
}

/**
 * 带 items 数组的事件：将 items 从 event_params 中分离出来
 * Web Pixel 对 cart_viewed / checkout / search / collection 事件
 * 在顶层有独立的 items 字段
 */
const EVENTS_WITH_ITEMS = new Set([
  "cart_viewed",
  "search_submitted",
  "collection_viewed",
  "checkout_started",
  "checkout_completed",
]);

/** 构建完整的事件 payload，与 Web Pixel 上报格式一致 */
export function buildEventPayload(
  eventName: string,
  data?: EventParams
): EventPayload {
  const eventParams: Record<string, unknown> = {};
  let items: ItemData[] | undefined;

  if (data) {
    // 分离 items 和 event_params
    for (const [key, value] of Object.entries(data)) {
      if (key === "items" && EVENTS_WITH_ITEMS.has(eventName)) {
        items = value as ItemData[];
      } else {
        eventParams[key] = value;
      }
    }
  }

  return {
    event_id: generateUUID(),
    event_name: eventName,
    event_timestamp: new Date().toISOString(),
    seq: configManager.nextSeq(),
    client_id: getOrCreateClientId(),
    customer: configManager.customer,
    shop: configManager.shop,
    page: getPageData(),
    traffic: getTrafficData(),
    event_params: eventParams,
    ...(items ? { items } : {}),
    consent: configManager.consent,
    pixel_version: configManager.version,
    sdk_type: "headless",
  };
}
